import { HTMLProps } from "react";
import { Paragraph } from "@datagame/ui";
import classNames from "classnames/bind";

import styles from "./SliderInput.module.scss";

const cx = classNames.bind(styles);

export type SliderInputProps = Omit<HTMLProps<HTMLInputElement>, "size">;

export const SliderInput = ({ value, min, max, onChange, className, ...restProps }: SliderInputProps) => {
  return (
    <div className={styles.sliderWrapper}>
      <input
        {...restProps}
        className={cx("slider", className)}
        type="range"
        min={min}
        max={max}
        value={value}
        onChange={onChange}
      />

      <Paragraph color="secondary" weight="font-bold">
        {value}
      </Paragraph>
    </div>
  );
};
